import Form from "./form";
import { AttendanceLocal } from "../../../../../../../../../../../@types/attendance-local";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentQueue } from "../../../../../../../../../../../@types/attendance-local-department-queue";
import { useAttendanceLocalDepartmentQueueUpdate } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/queue/update";

type FormUpdateProps = {
    departmentId: AttendanceLocalDepartment["id"];
    slug: AttendanceLocal["slug_unidade"];
    queue: AttendanceLocalDepartmentQueue;
    buttonTrigger?: React.ReactNode;
};

export default function FormUpdate(props: FormUpdateProps) {
    const mutation = useAttendanceLocalDepartmentQueueUpdate(props.queue.id);

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
